// Dependencies.
import styled from 'styled-components'

import { fontWeights, colors, icons } from '../utils'

const Button = styled.div`
  font-weight: ${fontWeights.semiBold};
  color: ${colors.purple};
  padding: 20px;
  &:hover {
    cursor: pointer;
  }
`

export const LoadMoreButton: React.FC = ({ children }) => (
  <Button>
    {children}{' '}
    <img src={icons.arrowDown} alt="arrow down" className="arrowDown" />
  </Button>
)
